/**
 * Created by Daniela on 12/09/2016.
 */
export class GrupoMaterial {
  ativo: boolean;
  dataCriacao: string;
  dataUltimaAlteracao: string;
  descricao: string;
  codigo: number;
  id: number;
  codigoGrupo: number;
  grupoId: number;
  usuarioCriacaoId: number;
  usuarioUltimaAlteracaoId: number;
  contaContabilId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/grupo-material.model.ts
 **/